import { LazyCompilerService, LAZY_COMPILER_SERVICE } from './lazy-compiler.service';

import uiRouterModule from "@uirouter/angularjs";

import { IHttpProvider, ICompileProvider } from "angular";
import { AuthInterceptor } from './core.authInterceptor';
import { TOKEN_SERVICE, TokenService } from './token.service';
import { HeaderService, HEADER_SERVICE } from './header.service';
import { AuthService, AUTH_SERVICE } from './auth.service';
import * as angular from "angular";

import layoutModule from "../layout/layout.module";

import "angular-material/angular-material.css";
import { NOTIFICATION_SERVICE, NotificationService } from "./notification.service";

export default angular
    .module("board.web.admin.core", [
        uiRouterModule,
        require("angular-material"),
        require("ngclipboard"),
        layoutModule
    ])
    .service(AUTH_SERVICE, AuthService)
    .service(TOKEN_SERVICE, TokenService)
    .service(HEADER_SERVICE, HeaderService)
    .service(NOTIFICATION_SERVICE, NotificationService)

    .config(["$compileProvider", "$provide", ($compileProvider: ICompileProvider, $provide: any) => {
        $provide.constant("$compileProvider", $compileProvider);
    }])
    .service(LAZY_COMPILER_SERVICE, LazyCompilerService);


// WEBPACK FOOTER //
// ./app/core/core.module.ts